<template>
  <section class="content">
    <div class="warning-block">
      <span class="text-red">＊</span>
      現折活動模組已搬至「
      <a @click="goto" class="cursor-pointer">新後台管理系統 > 行銷活動管理 > 現折活動管理</a>
      」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。
    </div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">停賣列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="form-group text-left">
              <div class="btn btn-default btn-table-title disabled">新增折扣活動</div>
            </div>
            <div class="form-group text-left">
              <div class="btn btn-default btn-table-title disabled">管理活動列表</div>
            </div>
            <br>
            <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
              <!-- <select class="form-control h-38" v-model="brandSelect">
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select> -->
              <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="== 品牌 =="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                    @input="getAttendDiscount"
                  >
               </multiselect>
            </div>
            <div class="form-group" v-if="brandSelect !== 999999 && brandSelect !== '999999' && storeBrief.length > 2">
              <!-- <select class="form-control h-38" v-model="storeSelect">
                <option v-for="store in storeBrief" :value="store.value">
                  {{store.label}}
                </option>
              </select> -->
              <multiselect
                v-model="storeSelect"
                :options="storeBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 門市 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
                @input="getAttendDiscount"
              >
              </multiselect>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="ruleCodeSelect" @change="getAttendDiscount">
                <option :value="999999">== 折扣規則 ==</option>
                <option
                  v-for="item in ruleCode" 
                  :value="item.rule_code"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="timeMethodSelect" @change="getAttendDiscount">
                <option :value="999999">== 狀態 ==</option>
                <option value="notyet">未開始</option>
                <option value="going">進行中</option>
                <option value="end">已結束</option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="isEnableSelect" @change="getAttendDiscount">
                <option :value="999999">== 啟用狀態 ==</option>
                <option value="1">啟用</option>
                <option value="0">未啟用</option>
              </select>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('id')">折扣活動 (ID)
                      <span v-if="sortMethod === 'id'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                          <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">折扣規則 (代碼)</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>-->
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">擁有者</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('start_date')">活動開始
                      <span v-if="sortMethod === 'start_date'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('end_date')">活動結束
                      <span v-if="sortMethod === 'end_date'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">你訂平台</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">街口平台</th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="discountList.length === 0">
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="discountList.length > 0">
                    <tr class="even" role="row" v-for="(discount, index) in discountList">
                      <td class="sorting_1">{{index + 1}}</td>
                      <td>
                        <router-link v-if="canEdit(discount)" :to="'/discountInfo/' + discount.activity_id">
                          {{discount.name}} ({{discount.activity_id}})
                        </router-link>
                        <div v-else>{{discount.name}} ({{discount.activity_id}})</div>
                      </td>
                      <td>{{discount.rule_name}} ({{discount.rule_code}})</td>
                      <!--<td>{{discount.description}}</td>-->
                      <!--<td>{{discount.sort}}</td>-->
                      <td>
                        <label class="label label-default" v-if="discount.time_method === 'notyet'">未開始</label>
                        <label class="label label-success" v-else-if="discount.time_method === 'going'">進行中</label>
                        <label class="label label-danger" v-else-if="discount.time_method === 'end'">已結束</label>
                      </td>
                      <td>
                        <label class="label label-success" v-if="discount.is_enable === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                      <td>
                        <span v-if="discount.owner_type === 1">平台</span>
                        <span v-if="discount.owner_type === 2">{{discount.owner_brand_name}} ({{discount.owner_id}})</span>
                        <span v-if="discount.owner_type === 3">{{discount.owner_brand_name}} - {{discount.owner_store_name}} ({{discount.owner_id}})</span>
                      </td>
                      <td>{{discount.start_date}}</td>
                      <td>{{discount.end_date}}</td>
                      <td>
                        <label class="label label-success" v-if="discount.is_platform_visible === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                      <td>
                        <label class="label label-success" v-if="discount.dedicated_visible_setting[0] === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="storesModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">"{{current.name}}"使用門市</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 p-x-0">
                <label class="label label-primary" style="margin-right: 5px" v-for="store in current.store_list">{{store.name}}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { setSharedToken } from '../../../assets/js/shared-token.js'

export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        label: '== 品牌 ==',
        value: 999999
      },
      storeSelect: {
        label: '== 門市 ==',
        value: 999999
      },
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      isEnableSelect: 999999,
      discountList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      isLoading: true,
      ruleCode: [
        {
          name: '買X送一依金額個位數取固定折抵規則',
          rule_code: 'SD00001'
        },
        {
          name: '買指定商品買X份可折Y元',
          rule_code: 'SD00002'
        },
        {
          name: '買X送Y依消費商品最低價折抵規則',
          rule_code: 'SD00003'
        },
        {
          name: '全品項折扣規則',
          rule_code: 'SD00004'
        },
        {
          name: '購買X數量滿額可折Y元折抵規則',
          rule_code: 'SD00005'
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    canEdit (discount) {
      // 符合 ECMS 可編輯活動
      const list = this.ruleCode.map(item => item.rule_code)
      return list.includes(discount.rule_code)
    },
    checkSort (method) {
      this.sortMethod = method
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle
        else {
          this.tableIndex = 1
          this.sortToggle = false
        }
        this.preSortMethod.splice(0, 1)
      } else this.sortToggle = false
      this.preSortMethod.push(method)
      this.getAttendDiscount()
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = [{label: '==門市==', value: 999999}]
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj
            } else if (i === 0) self.storeSelect.value = 999999
          }
          if (!sList.length) {
            self.discountList = []
            self.total = 0
          }
          self.getAttendDiscount()
        }
      })
    },
    getAttendDiscount () {
      this.isLoading = true
      var self = this
      var url = '/discount/listForAttend?page=' + this.tableIndex + '&size=' + this.count + '&attend_brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== 999999) url = url + '&attend_store_id=' + this.storeSelect.value
      if (this.ruleCodeSelect !== 999999) url = url + '&rule_code=' + this.ruleCodeSelect
      if (this.timeMethodSelect !== 999999) url = url + '&time_method=' + this.timeMethodSelect
      if (this.isEnableSelect !== 999999) url = url + '&is_enable=' + this.isEnableSelect
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' '
        if (this.sortToggle) url = url + 'ASC'
        else url = url + 'DESC'
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.discountList = response.data.list
          self.total = response.data.list_total
          self.isLoading = false
        }
      })
    },
    clickCurrent (menu) {
      this.current = menu
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getAttendDiscount()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = `${this.$config.bdms}promotions/discount`
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'brandSelect.value' () {
      this.storeSelect = {
        value: 999999,
        label: '== 門市 =='
      }
      this.getStoreBrief(this.brandSelect.value)
    },
    'storeSelect.value' () {
      this.getAttendDiscount()
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
.info {
  padding: 1rem 0;
}
.warning-block {
  padding: 10px;
  border: 1px solid #F39C12;
  background-color: #FFF4E3;
  margin-top: 4px;
  margin-bottom: 12px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// DiscountTable.vue?3698a42a